export const endpoint = {
  uploadFor: (id:number) => `/case/draft/${id}/document`
};
